import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive } from 'styles/constants/primitives';

export const ChallengeProgressCardSkeleton = () => {
  return (
    <>
      <View style={styles.card}>
        <Skeleton
          style={{
            width: 144,
            margin: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            height: '100%',
          }}
        />
        <View style={styles.right}>
          <Skeleton style={{ width: '100%', height: 12, margin: 0 }} />
          <Skeleton style={{ width: '40%', height: 12 }} />
          <Skeleton style={{ width: '100%', height: 12, marginBottom: 0 }} />
          <Skeleton style={{ width: '60%', height: 12 }} />
          <View style={styles.footer}>
            <Skeleton style={{ width: '40%', height: 12, margin: 0 }} />
            <Skeleton style={{ width: '40%', height: 12, margin: 0 }} />
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    backgroundColor: primitive.$white,
    borderRadius: 12,
    alignItems: 'center',
  },
  left: {
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    position: 'relative',
    justifyContent: 'center',
  },
  right: {
    paddingHorizontal: primitive.spacing.$4,
    paddingVertical: primitive.spacing.$6,
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    flex: 1,
  },
  leftIcon: {
    width: 108,
    height: 108,
  },
  footer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: primitive.spacing.$4,
    marginTop: primitive.spacing.$3,
    justifyContent: 'space-between',
  },
  footerHalfWidthButton: {
    width: '50%',
  },
  baseTag: {
    borderRadius: 4,
    backgroundColor: primitive.$white,
    flexDirection: 'row',
    gap: primitive.spacing.$1,
    alignItems: 'center',
    paddingHorizontal: 6,
    position: 'absolute',
    top: 8,
    left: 8,
  },
  earnedCrownsTag: {
    backgroundColor: primitive.bk.$meltyYellow,
  },
  tagIcon: {
    width: 12,
    height: 12,
  },
  circularProgressContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
